// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog_blog__z2P6a","item":"Blog_item__pCC5A","label":"Blog_label__oMrhr","text":"Blog_text__IjVZK","btnBottom":"Blog_btnBottom__U3zNO"};